// @ts-nocheck
import {useInfiniteQuery} from "@tanstack/react-query";
import {getGameFeedService} from "../../services/games/gameFeed/gameFeed.service";
import {useAuthStore} from "../../store/useAuth.store";

const PAGE_SIZE = 10;

const useGetGameFeed = () => {
  const authStatus = useAuthStore(state => state.authStatus);
  const isAuthenticated = authStatus === "authenticated";

  const {data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isError, error, refetch} = useInfiniteQuery({
    queryKey: ["gameFeed", isAuthenticated],
    queryFn: ({pageParam = 1}) => getGameFeedService(pageParam, PAGE_SIZE, isAuthenticated),
    getNextPageParam: (lastPage, allPages) => {
      const feedData = lastPage?.data?.data;
      if (!feedData) return undefined;
      const totalPages = Math.ceil(feedData.total / feedData.page_size);
      const nextPage = allPages.length + 1;
      return nextPage <= totalPages ? nextPage : undefined;
    },
    staleTime: 60 * 1000,
  });

  const games = data?.pages?.flatMap(page => page?.data?.data?.games ?? []) ?? [];

  return {
    games,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isError,
    error,
    refetch,
  };
};

export default useGetGameFeed;
